import * as React from 'react';
import Button from '../Button';
import { IButtonProps } from '../Button/Button';
import './BadgeButton.scss';

interface IBadgeButtonProps extends IButtonProps {
  badgeValue: number;
}

const BadgeButton: React.FC<IBadgeButtonProps> = ({ badgeValue, ...props }) => {
  return (
    <div className="rp-badge-button-container">
      {badgeValue > 0 && <span className="rp-badge">{badgeValue}</span>}
      <Button {...props} />
    </div>
  );
};

export default BadgeButton;
